
function totalItemsQuantity(containerId, itemClass, inputClass) {
    let totalQuantity = 0;
    const items = $('#' + containerId).find('.' + itemClass);
    items.each(function () {
        let quantity = $(this).find('.' + inputClass).val();
        totalQuantity += parseInt(quantity);
    })
    return totalQuantity;
}

function toggleSubmitState(containerId, submitButtonClass, quantity) {
    const btn = $('#' + containerId).find('.' + submitButtonClass);
    if(quantity < 1) {
        btn.prop('disabled', true);
        return;
    }
    btn.prop('disabled', false);
}


$(document).ready(function(){

    $('.return-item-quantity').on('change', function() {
        toggleSubmitState(
            'create-retour-modal',
            'create-retour',
            totalItemsQuantity('create-retour-modal', 'is-cart-item', 'return-item-quantity' ));
    })

});
